import { render, staticRenderFns } from "./MainContainer.vue?vue&type=template&id=3d05d410&scoped=true"
import script from "./MainContainer.vue?vue&type=script&lang=js"
export * from "./MainContainer.vue?vue&type=script&lang=js"
import style0 from "./MainContainer.vue?vue&type=style&index=0&id=3d05d410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d05d410",
  null
  
)

export default component.exports